import userHttp from "../axios.services/instances/userHttp";
import { isTokenExpired } from "./jwtUtils";

type RefreshApiOk = {
  accessToken: string;
  expiresAtUtc: string;
};

class SessionManagerClass {
  private accessToken: string | null = null;
  private expiresAtUtc: string | null = null;
  private refreshingPromise: Promise<void> | null = null;

  getAccessToken() {
    return this.accessToken;
  }

  setAccessToken(token: string | null, expiresAtUtc?: string | null) {
    this.accessToken = token;
    if (expiresAtUtc !== undefined) this.expiresAtUtc = expiresAtUtc;
  }

  clear() {
    this.accessToken = null;
    this.expiresAtUtc = null;
  }

  hasValidToken(): boolean {
    return !isTokenExpired(this.accessToken, this.expiresAtUtc, 5); // 5 sec skew
  }

  async bootstrap(): Promise<boolean> {
    if (this.hasValidToken()) return true;

    try {
      await this.refreshToken();
      return true;
    } catch {
      this.clear();
      return false;
    }
  }

  async refreshToken(): Promise<void> {
    if (this.refreshingPromise) return this.refreshingPromise;

    this.refreshingPromise = (async () => {
      const resp = await userHttp.post("/api/v1/auth/refresh", {});

      const payload: RefreshApiOk | undefined = resp?.data;

      if (!payload?.accessToken || !payload?.expiresAtUtc) {
        throw new Error("Refresh did not return accessToken/expiresAtUtc.");
      }

      this.accessToken = payload.accessToken;
      this.expiresAtUtc = payload.expiresAtUtc;
      this.accessToken = payload.accessToken;
    })().finally(() => {
      this.refreshingPromise = null;
    });

    return this.refreshingPromise;
  }
}

export const SessionManager = new SessionManagerClass();
export default SessionManager;

// class SessionManagerClass {
//   private accessToken: string | null = null;
//   private refreshingPromise: Promise<void> | null = null;

//   getAccessToken() {
//     return this.accessToken;
//   }

//   setAccessToken(token: string | null) {
//     this.accessToken = token;
//   }

//   clear() {
//     this.accessToken = null;
//   }

//   hasValidToken(): boolean {
//     const t = this.accessToken;
//     if (!t) return false;
//     return !isJwtExpired(t);
//   }

//   // App load: if token missing/expired -> refresh using httpOnly cookies
//   async bootstrap(): Promise<void> {
//     const t = this.accessToken;
//     if (t && !isJwtExpired(t)) return;
//     await this.refreshToken();
//   }

//   async refreshToken(): Promise<void> {
//     if (this.refreshingPromise) return this.refreshingPromise;

//     this.refreshingPromise = (async () => {
//       try {
//         // IMPORTANT:
//         // Body empty/anything. Server MUST read rt + session_token from cookies.
//         const resp = await userHttp.post("/api/v1/auth/refresh", {});
//         const payload: RefreshApiOk | undefined = resp?.data?.data;

//         console.log({resp});

//         if (!payload?.accessToken) throw new Error("No accessToken returned.");

//         this.accessToken = payload.accessToken;
//       } finally {
//         this.refreshingPromise = null;
//       }
//     })();

//     return this.refreshingPromise;
//   }
// }

// export const SessionManager = new SessionManagerClass();
// export default SessionManager;

// type RefreshApiOk = {
//   accessToken: string;
//   expiresAtUtc: string;
//   sessionToken: string;
//   newRefreshToken?: string; // ideally not used in browser
//   newRefreshTokenExpiresAtUtc?: string;
// };
// // type AuthPayload = {
// //   aut?: string;
// //   sid?: string;
// //   expiry?: string;
// //   uid: string;
// //   role: string;
// // };

// type AuthPayload = {
//   token?: string;
//   sessionId?: string;
//   expiresAtUtc?: string;
// };
// const COOKIE_TOKEN = "_at";
// const COOKIE_SESSION = "_st";
// const BROADCAST_CHANNEL = "_auth";
// // const COOKIE_TOKEN = "bbps_token";
// // const COOKIE_SESSION = "bbps_sessionid";
// // const BROADCAST_CHANNEL = "bbps-auth";

// class SessionManagerClass {
//   private accessToken: string | null = null; // in-memory token
//   private sessionId: string | null = null; // in-memory sessionId
//   private expiresAtUtc: string | null = null; // in-memory expiry
//   private refreshingPromise: Promise<void> | null = null; // single refresh queue
//   private bc: BroadcastChannel | null = null; // Broadcast channel if available

//   constructor() {
//     // Initialize from cookies (so reload is covered)
//     this.accessToken = Cookies.get(COOKIE_TOKEN) || null;
//     this.sessionId = Cookies.get(COOKIE_SESSION) || null;

//     // Setup BroadcastChannel if browser supports it
//     if (typeof window !== "undefined" && "BroadcastChannel" in window) {
//       this.bc = new BroadcastChannel(BROADCAST_CHANNEL);
//       this.bc.onmessage = (ev) => {
//         const { type, payload } = ev.data || {};
//         if (type === "SET_TOKEN") {
//           // when another tab sets token -> update in-memory copy
//           this.accessToken = payload?.token ?? null;
//           this.sessionId = payload?.sessionId ?? null;
//           this.expiresAtUtc = payload?.expiresAtUtc ?? null;
//         }
//         if (type === "CLEAR") {
//           // when another tab logs out -> clear local cache
//           this.clearLocalOnly();
//         }
//       };
//     }

//     // fallback: storage event for older browsers
//     window.addEventListener("storage", (e) => {
//       if (e.key === "cashquin-auth") {
//         try {
//           const msg = JSON.parse(String(e.newValue));
//           if (msg?.type === "SET_TOKEN") {
//             this.accessToken = msg.payload?.token ?? null;
//             this.sessionId = msg.payload?.sessionId ?? null;
//             this.expiresAtUtc = msg.payload?.expiresAtUtc ?? null;
//           }
//           if (msg?.type === "CLEAR") {
//             this.clearLocalOnly();
//           }
//         } catch (err) {
//           // ignore parse errors
//         }
//       }
//     });
//   }

//   // Set token/sessionId/expiry -> write cookies + update memory + broadcast to other tabs
//   setAuth(payload: AuthPayload) {
//     const prevToken = this.accessToken;
//     const prevSid = this.sessionId;

//     if (payload.token) this.accessToken = payload.token;
//     if (payload.sessionId) this.sessionId = payload.sessionId;
//     if (payload.expiresAtUtc) this.expiresAtUtc = payload.expiresAtUtc;

//     // Set cookie for token (non-HttpOnly fallback). Prefer server-set HttpOnly cookies.
//     //   if (payload.token) {
//     //     const expires = payload.expiresAtUtc
//     //       ? new Date(payload.expiresAtUtc)
//     //       : undefined;
//     //     Cookies.set(COOKIE_TOKEN, payload.token!, {
//     //       expires,
//     //       secure: true,
//     //       sameSite: "Lax",
//     //       path: "/",
//     //     });
//     //   }

//     //   // Set cookie for sessionId
//     //   if (payload.sessionId) {
//     //     const expires = payload.expiresAtUtc
//     //       ? new Date(payload.expiresAtUtc)
//     //       : undefined;
//     //     Cookies.set(COOKIE_SESSION, payload.sessionId!, {
//     //       expires,
//     //       secure: true,
//     //       sameSite: "Lax",
//     //       path: "/",
//     //     });
//     //   }

//     //   // Broadcast to other tabs
//     //   const message = { type: "SET_TOKEN", payload };
//     //   try {
//     //     this.bc?.postMessage(message);
//     //   } catch {
//     //     // fallback using localStorage event
//     //     localStorage.setItem("bbps-auth", JSON.stringify(message));
//     //     // remove quickly to avoid piling storage keys
//     //     setTimeout(() => localStorage.removeItem("bbps-auth"), 500);
//     //   }
//     // }
//     // Optional: store access token for reload convenience
//     if (payload.token && payload.token !== prevToken) {
//       const expires = payload.expiresAtUtc
//         ? new Date(payload.expiresAtUtc)
//         : undefined;
//       Cookies.set(COOKIE_TOKEN, payload.token, {
//         expires,
//         secure: true,
//         sameSite: "Lax",
//         path: "/",
//       });
//     }

//     // Optional: store sessionId (NOT the httpOnly session_token; this is your own tracking cookie)
//     if (payload.sessionId && payload.sessionId !== prevSid) {
//       const expires = payload.expiresAtUtc
//         ? new Date(payload.expiresAtUtc)
//         : undefined;
//       Cookies.set(COOKIE_SESSION, payload.sessionId, {
//         expires,
//         secure: true,
//         sameSite: "Lax",
//         path: "/",
//       });
//     }

//     const message = { type: "SET_TOKEN", payload };
//     try {
//       this.bc?.postMessage(message);
//     } catch {
//       localStorage.setItem("cashquin-auth", JSON.stringify(message));
//       setTimeout(() => localStorage.removeItem("cashquin-auth"), 500);
//     }
//   }

//   // get token (memory -> cookie fallback)
//   getAccessToken() {
//     return this.accessToken || Cookies.get(COOKIE_TOKEN) || null;
//   }

//   // get session id
//   getSessionId() {
//     return this.sessionId || Cookies.get(COOKIE_SESSION) || null;
//   }

//   // convenience setters
//   setAccessToken(token?: string) {
//     if (!token) return;
//     this.setAuth({ token });
//   }
//   setSessionId(sessionId?: string) {
//     if (!sessionId) return;
//     this.setAuth({ sessionId });
//   }
//   setExpiry(expiresAtUtc?: string) {
//     if (!expiresAtUtc) return;
//     this.expiresAtUtc = expiresAtUtc;
//   }

//   // Remove tokens/cookies and broadcast CLEAR to other tabs
//   clear() {
//     this.clearLocalOnly();
//     const message = { type: "CLEAR" };
//     try {
//       this.bc?.postMessage(message);
//     } catch {
//       localStorage.setItem("cashquin-auth", JSON.stringify(message));
//       setTimeout(() => localStorage.removeItem("cashquin-auth"), 500);
//     }
//   }

//   // clear only in-memory and cookies (used by clear and broadcast handler)
//   private clearLocalOnly() {
//     this.accessToken = null;
//     this.sessionId = null;
//     this.expiresAtUtc = null;
//     Cookies.remove(COOKIE_TOKEN, { path: "/" });
//     Cookies.remove(COOKIE_SESSION, { path: "/" });
//   }

//   // clear and redirect to login page
//   clearAndRedirectToLogin() {
//     this.clear();
//     try {
//       window.location.replace("/login");
//     } catch (err) {
//       console.error("Failed to redirect to login page", err);
//     }
//   }

//   /**
//    * Bootstraps auth on site load:
//    * - If token exists and not expired -> ok
//    * - else try refresh using httpOnly cookies (rt + session_token)
//    */
//   async bootstrap(): Promise<void> {
//     const token = this.getAccessToken();
//     if (token && !isJwtExpired(token)) return;

//     // no token / expired -> attempt refresh
//     await this.refreshToken();
//   }

//   /**
//    * Refreshes access token:
//    * - Browser: do NOT send rt/st in JS (httpOnly cookies auto sent via withCredentials)
//    * - Server should validate & rotate
//    */
//   async refreshToken(): Promise<void> {
//     if (this.refreshingPromise) return this.refreshingPromise;

//     const promise = (async () => {
//       try {
//         // IMPORTANT: send empty body; cookies carry rt + session_token
//         const resp = await userHttp.post("/api/v1/auth/refresh", {
//           refreshToken: "",
//           sessionToken: "",
//         });

//         const payload: RefreshApiOk | undefined = resp?.data?.data;
//         if (!payload?.accessToken) throw new Error("No accessToken returned by refresh");

//         this.setAuth({
//           token: payload.accessToken,
//           sessionId: payload.sessionToken,     // if you want to track; otherwise store actual sessionId separately
//           expiresAtUtc: payload.expiresAtUtc,
//         });

//         // NOTE:
//         // If server rotates refresh token, it MUST also set new 'rt' cookie in response.
//         // Otherwise next refresh will fail unless you store payload.newRefreshToken in JS (not recommended).
//       } catch (err) {
//         this.clearAndRedirectToLogin();
//         throw err;
//       } finally {
//         this.refreshingPromise = null;
//       }
//     })();

//     this.refreshingPromise = promise;
//     return promise;
//   }

//   // basic validity check - returns true if a token exists; optionally decode expiry for stronger check
//   hasValidToken(): boolean {
//     const token = this.getAccessToken();
//     if (!token) return false;
//     // OPTIONAL: decode JWT to check expiry (avoid if token is opaque)
//     return true;
//   }
// }

// // export singleton
// export const SessionManager = new SessionManagerClass();
// export default SessionManager;
